<script setup>
const handleClick = (type) => {
  if (type === 'bitcoin') {
    window.open('https://utxoverse.xyz/bitcoin', '_blank')
  } else if (type === 'xsat') {
    window.open('https://utxoverse.xyz/xsat', '_blank')
  } else if (type === 'become') {
    window.open('https://docs.exsat.network/guides-of-data-consensus/run-a-btc-validator', '_blank')
  } else if (type === 'esBTC') {
    window.open('https://esbtc.exsat.network/', '_blank')
  }
}
const handleLearnMore = () => {
  window.open('https://docs.exsat.network/guides-of-data-consensus/run-a-btc-validator', '_blank')
}
</script>
<template>
  <svg
    width="358"
    height="1581"
    viewBox="0 0 358 1581"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <text
      fill="url(#paint0_linear_1844_3274)"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Satoshi Variable"
      font-size="28"
      font-weight="bold"
      letter-spacing="0em"
    >
      <tspan x="0" y="31.78">How does</tspan>
      <tspan x="252.848" y="31.78">Work</tspan>
    </text>
    <text
      fill="url(#paint1_linear_1844_3274)"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Satoshi Variable"
      font-size="28"
      font-weight="bold"
      letter-spacing="0em"
    >
      <tspan x="136.746" y="31.78">Validator</tspan>
    </text>
    <text
      fill="#8C8C8C"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Inter"
      font-size="12"
      letter-spacing="0em"
    >
      <tspan x="0" y="59.3636">Synchronizer plays a key role in the MetaData Sync Protocol</tspan>
      <tspan x="0" y="77.3636">and is typically coming from Bitcoin mining pools. There are</tspan>
      <tspan x="0" y="95.3636">criterion and incentives to synchronizers which ensure they</tspan>
      <tspan x="0" y="113.364">perform their tasks accurately and promptly.</tspan>
    </text>
    <text
      fill="#8C8C8C"
      xml:space="preserve"
      style="white-space: pre; cursor: pointer"
      font-family="Inter"
      font-size="12"
      letter-spacing="0em"
      text-decoration="underline"
      @click="handleLearnMore"
    >
      <tspan x="255.41" y="113.364">Learn more</tspan>
    </text>
    <path
      d="M0 138C0 133.582 3.58172 130 8 130H215C219.418 130 223 133.582 223 138V156C223 160.418 219.418 164 215 164H8C3.58172 164 0 160.418 0 156V138Z"
      fill="#111111"
      @click="handleClick('bitcoin')"
    />
    <text
      fill="white"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Inter"
      font-size="12"
      font-weight="600"
      letter-spacing="0em"
      @click="handleClick('bitcoin')"
    >
      <tspan x="8" y="151.364">Explorer BTC Validators &#38; Stake</tspan>
    </text>
    <path
      d="M203 151L211 143M211 143H205.667M211 143V148.333"
      stroke="#666666"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      @click="handleClick('bitcoin')"
    />
    <path
      d="M0 180C0 175.582 3.58172 172 8 172H175C179.418 172 183 175.582 183 180V198C183 202.418 179.418 206 175 206H8C3.58172 206 0 202.418 0 198V180Z"
      fill="#111111"
      @click="handleClick('xsat')"
    />
    <text
      fill="white"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Inter"
      font-size="12"
      font-weight="600"
      letter-spacing="0em"
      @click="handleClick('xsat')"
    >
      <tspan x="8" y="193.364">Explorer XSAT Validators</tspan>
    </text>
    <path
      d="M163 193L171 185M171 185H165.667M171 185V190.333"
      stroke="#666666"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M191 180C191 175.582 194.582 172 199 172H332C336.418 172 340 175.582 340 180V198C340 202.418 336.418 206 332 206H199C194.582 206 191 202.418 191 198V180Z"
      fill="#111111"
      @click="handleClick('become')"
    />
    <text
      fill="white"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Inter"
      font-size="12"
      font-weight="600"
      letter-spacing="0em"
      @click="handleClick('become')"
    >
      <tspan x="199" y="193.364">Become a validator</tspan>
    </text>
    <path
      d="M320 193L328 185M328 185H322.667M328 185V190.333"
      stroke="#666666"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      @click="handleClick('become')"
    />
    <path
      d="M0 222C0 217.582 3.58172 214 8 214H104C108.418 214 112 217.582 112 222V240C112 244.418 108.418 248 104 248H8C3.58172 248 0 244.418 0 240V222Z"
      fill="#111111"
      @click="handleClick('esBTC')"
    />
    <text
      fill="white"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Inter"
      font-size="12"
      font-weight="600"
      letter-spacing="0em"
      @click="handleClick('esBTC')"
    >
      <tspan x="8" y="235.364">Access esBTC</tspan>
    </text>
    <path
      d="M92 235L100 227M100 227H94.6667M100 227V232.333"
      stroke="#666666"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      @click="handleClick('esBTC')"
    />
    <g clip-path="url(#clip0_1844_3274)">
      <rect y="288" width="358" height="681" rx="24" fill="#131313" />
      <g clip-path="url(#clip1_1844_3274)">
        <rect
          x="11.2952"
          y="796.295"
          width="355.41"
          height="185.97"
          rx="11.5124"
          fill="#1C1C1C"
          stroke="#2D2D2D"
          stroke-width="0.590381"
        />
        <path
          d="M55.5737 855.333V875.997C55.5737 877.953 57.1597 879.539 59.116 879.539H99.8523C101.809 879.539 103.395 877.953 103.395 875.997V836.441C103.395 834.485 104.981 832.899 106.937 832.899H177.488C179.444 832.899 181.03 834.485 181.03 836.441V858.285"
          stroke="#111111"
          stroke-width="8.85572"
        />
        <path
          d="M65.3152 948.909H179.259C181.215 948.909 182.801 947.323 182.801 945.367V915.847"
          stroke="#111111"
          stroke-width="8.85572"
        />
        <path
          d="M200.512 884.557H314.456C316.412 884.557 317.998 886.143 317.998 888.1V917.619"
          stroke="#111111"
          stroke-width="8.85572"
        />
        <path d="M200.512 901.088H317.998" stroke="#111111" stroke-width="8.85572" />
        <g opacity="0.6">
          <foreignObject x="8.62492" y="787.721" width="93.3075" height="106.007">
            <div
              xmlns="http://www.w3.org/1999/xhtml"
              style="
                backdrop-filter: blur(12.7px);
                clip-path: url(#bgblur_2_1844_3274_clip_path);
                height: 100%;
                width: 100%;
              "
            ></div>
          </foreignObject>
          <g filter="url(#filter0_d_1844_3274)" data-figma-bg-blur-radius="25.4">
            <ellipse
              cx="55.2786"
              cy="834.375"
              rx="21.2537"
              ry="21.2537"
              fill="#343434"
              style="mix-blend-mode: luminosity"
              shape-rendering="crispEdges"
            />
            <path
              d="M55.2788 813.717C66.6881 813.717 75.937 822.966 75.937 834.375C75.9369 845.784 66.688 855.033 55.2788 855.033C43.8695 855.033 34.6207 845.784 34.6206 834.375C34.6206 822.966 43.8695 813.717 55.2788 813.717Z"
              stroke="url(#paint2_linear_1844_3274)"
              stroke-opacity="0.25"
              stroke-width="1.19062"
              shape-rendering="crispEdges"
            />
          </g>
          <g clip-path="url(#clip3_1844_3274)">
            <mask
              id="mask0_1844_3274"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="33"
              y="809"
              width="45"
              height="47"
            >
              <ellipse cx="55.4797" cy="832.593" rx="22.0039" ry="23.0353" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_1844_3274)">
              <path
                d="M46.5237 829.211C46.5237 824.14 50.4429 820.029 55.2781 820.029C60.1133 820.029 64.0325 824.14 64.0325 829.211C64.0325 834.282 60.1133 838.394 55.2781 838.394C50.4429 838.394 46.5237 834.282 46.5237 829.211Z"
                fill="url(#paint3_linear_1844_3274)"
              />
              <path
                d="M55.2786 841.03C64.457 841.03 71.9391 847.61 72.5159 856.412H38.0413C38.618 847.61 46.1002 841.03 55.2786 841.03Z"
                fill="url(#paint4_linear_1844_3274)"
                stroke="#B9B9B9"
                stroke-width="0.559309"
              />
            </g>
          </g>
        </g>
        <rect x="24.2835" y="850.02" width="61.3997" height="15.3499" rx="6.19901" fill="#070707" />
        <rect
          x="24.2835"
          y="850.02"
          width="61.3997"
          height="15.3499"
          rx="6.19901"
          stroke="#1B1B1B"
          stroke-width="0.590381"
        />
        <text
          fill="#828282"
          xml:space="preserve"
          style="white-space: pre"
          font-family="Chakra Petch"
          font-size="12"
          font-weight="500"
          letter-spacing="0em"
        >
          <tspan x="30.8452" y="862.185">Validator</tspan>
        </text>
        <g opacity="0.6">
          <foreignObject x="8.62492" y="880.411" width="93.3075" height="106.007">
            <div
              xmlns="http://www.w3.org/1999/xhtml"
              style="
                backdrop-filter: blur(12.7px);
                clip-path: url(#bgblur_4_1844_3274_clip_path);
                height: 100%;
                width: 100%;
              "
            ></div>
          </foreignObject>
          <g filter="url(#filter1_d_1844_3274)" data-figma-bg-blur-radius="25.4">
            <ellipse
              cx="55.2786"
              cy="927.065"
              rx="21.2537"
              ry="21.2537"
              fill="#343434"
              style="mix-blend-mode: luminosity"
              shape-rendering="crispEdges"
            />
            <path
              d="M55.2788 906.407C66.6881 906.407 75.937 915.656 75.937 927.065C75.9369 938.474 66.688 947.723 55.2788 947.723C43.8695 947.723 34.6207 938.474 34.6206 927.065C34.6206 915.655 43.8695 906.407 55.2788 906.407Z"
              stroke="url(#paint5_linear_1844_3274)"
              stroke-opacity="0.25"
              stroke-width="1.19062"
              shape-rendering="crispEdges"
            />
          </g>
          <g clip-path="url(#clip5_1844_3274)">
            <mask
              id="mask1_1844_3274"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="33"
              y="902"
              width="45"
              height="47"
            >
              <ellipse cx="55.4797" cy="925.283" rx="22.0039" ry="23.0353" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask1_1844_3274)">
              <path
                d="M46.5237 921.901C46.5237 916.83 50.4429 912.718 55.2781 912.718C60.1133 912.718 64.0325 916.83 64.0325 921.901C64.0325 926.972 60.1133 931.084 55.2781 931.084C50.4429 931.084 46.5237 926.972 46.5237 921.901Z"
                fill="url(#paint6_linear_1844_3274)"
              />
              <path
                d="M55.2786 933.72C64.457 933.72 71.9391 940.3 72.5159 949.102H38.0413C38.618 940.3 46.1002 933.72 55.2786 933.72Z"
                fill="url(#paint7_linear_1844_3274)"
                stroke="#B9B9B9"
                stroke-width="0.559309"
              />
            </g>
          </g>
        </g>
        <rect
          x="24.2835"
          y="940.939"
          width="61.3997"
          height="15.3499"
          rx="6.19901"
          fill="#070707"
        />
        <rect
          x="24.2835"
          y="940.939"
          width="61.3997"
          height="15.3499"
          rx="6.19901"
          stroke="#1B1B1B"
          stroke-width="0.590381"
        />
        <text
          fill="#828282"
          xml:space="preserve"
          style="white-space: pre"
          font-family="Chakra Petch"
          font-size="12"
          font-weight="500"
          letter-spacing="0em"
        >
          <tspan x="30.8452" y="953.104">Validator</tspan>
        </text>
        <rect
          x="126.134"
          y="850.324"
          width="112.744"
          height="77.9614"
          rx="8.8464"
          fill="#272727"
          stroke="url(#paint8_linear_1844_3274)"
          stroke-width="1.19941"
        />
        <rect x="137.941" y="862.132" width="89.129" height="54.2964" rx="8.99555" fill="#111111" />
        <rect
          x="137.941"
          y="862.132"
          width="89.129"
          height="54.2964"
          rx="8.99555"
          stroke="#202020"
          stroke-width="1.19941"
        />
        <g filter="url(#filter2_dddddd_1844_3274)">
          <text
            transform="translate(161.006 866.846)"
            fill="#9E9E9E"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Chakra Petch"
            font-size="18.6808"
            font-weight="bold"
            letter-spacing="-0.01em"
          >
            <tspan x="0" y="17.3888">&#62;2/3</tspan>
          </text>
        </g>
        <g filter="url(#filter3_dddddd_1844_3274)">
          <path
            d="M190.713 899.976L180.73 910.227C180.68 910.278 180.62 910.319 180.555 910.346C180.489 910.374 180.418 910.388 180.347 910.388C180.276 910.388 180.205 910.374 180.139 910.346C180.074 910.319 180.014 910.278 179.964 910.227L174.298 904.834C174.2 904.734 174.146 904.6 174.146 904.46C174.146 904.32 174.2 904.185 174.298 904.085L176.62 901.843C176.67 901.792 176.73 901.752 176.796 901.724C176.861 901.697 176.932 901.682 177.003 901.682C177.074 901.682 177.145 901.697 177.211 901.724C177.276 901.752 177.336 901.792 177.386 901.843L179.948 904.224L187.257 896.611C187.307 896.559 187.367 896.518 187.433 896.49C187.499 896.462 187.57 896.447 187.642 896.447C187.714 896.447 187.785 896.462 187.851 896.49C187.918 896.518 187.977 896.559 188.027 896.611L190.703 899.227C190.802 899.326 190.859 899.459 190.861 899.599C190.863 899.739 190.81 899.875 190.713 899.976Z"
            fill="url(#paint9_linear_1844_3274)"
          />
        </g>
        <circle cx="135.129" cy="859.32" r="2.39881" fill="#525252" />
        <circle cx="231.082" cy="859.32" r="2.39881" fill="#525252" />
        <circle cx="135.129" cy="919.29" r="2.39881" fill="#343434" />
        <circle cx="231.082" cy="919.29" r="2.39881" fill="#343434" />
        <g clip-path="url(#clip6_1844_3274)">
          <g filter="url(#filter4_f_1844_3274)">
            <rect
              x="114.317"
              y="828.471"
              width="20.073"
              height="8.85572"
              rx="4.42786"
              fill="url(#paint10_linear_1844_3274)"
            />
          </g>
          <g filter="url(#filter5_f_1844_3274)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M122.55 830.278L123.745 830.575L124.012 829.652L124.61 829.802L124.353 830.687L124.84 830.809L125.098 829.914L125.706 830.065L125.444 830.964C125.444 830.964 126.437 831.168 126.67 831.917C126.904 832.666 126.157 833.059 125.926 833.074C125.926 833.074 126.796 833.516 126.497 834.387C126.198 835.257 125.281 835.412 124.316 835.213L124.054 836.146L123.446 835.995L123.713 835.077L123.231 834.955L122.964 835.88L122.361 835.729L122.628 834.809L121.401 834.502L121.711 833.865C121.711 833.865 122.057 833.953 122.188 833.982C122.319 834.011 122.403 833.885 122.44 833.758C122.476 833.632 123.032 831.54 123.084 831.367C123.137 831.195 123.116 831.06 122.895 831.007C122.675 830.954 122.375 830.871 122.375 830.871L122.55 830.278ZM123.755 833.049L123.424 834.27C123.424 834.27 125.065 834.819 125.275 834.046C125.485 833.273 123.755 833.049 123.755 833.049ZM123.908 832.471L124.232 831.353C124.232 831.353 125.638 831.586 125.465 832.208C125.291 832.83 124.463 832.592 123.908 832.471Z"
              fill="#848484"
            />
          </g>
        </g>
        <g clip-path="url(#clip7_1844_3274)">
          <g filter="url(#filter6_f_1844_3274)">
            <rect
              x="150.92"
              y="944.776"
              width="20.073"
              height="8.85572"
              rx="4.42786"
              fill="url(#paint11_linear_1844_3274)"
            />
          </g>
          <g filter="url(#filter7_f_1844_3274)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M159.153 946.583L160.348 946.88L160.616 945.957L161.213 946.107L160.957 946.992L161.444 947.114L161.701 946.219L162.309 946.37L162.047 947.27C162.047 947.27 163.04 947.473 163.274 948.222C163.507 948.971 162.76 949.364 162.529 949.379C162.529 949.379 163.399 949.822 163.101 950.692C162.802 951.562 161.885 951.718 160.92 951.518L160.658 952.451L160.05 952.3L160.317 951.382L159.835 951.26L159.567 952.185L158.964 952.035L159.232 951.114L158.005 950.807L158.314 950.17C158.314 950.17 158.66 950.258 158.791 950.287C158.922 950.316 159.006 950.19 159.043 950.064C159.08 949.937 159.636 947.845 159.688 947.672C159.74 947.5 159.719 947.366 159.499 947.312C159.279 947.259 158.979 947.177 158.979 947.177L159.153 946.583ZM160.359 949.355L160.028 950.575C160.028 950.575 161.669 951.124 161.879 950.351C162.089 949.578 160.359 949.355 160.359 949.355ZM160.511 948.776L160.836 947.658C160.836 947.658 162.241 947.891 162.068 948.513C161.895 949.135 161.067 948.897 160.511 948.776Z"
              fill="#848484"
            />
          </g>
        </g>
        <rect
          x="276.586"
          y="865.446"
          width="49.2297"
          height="48.1822"
          rx="9.95068"
          fill="url(#paint12_linear_1844_3274)"
          fill-opacity="0.22"
          stroke="#202020"
          stroke-width="1.04744"
        />
        <foreignObject x="260.351" y="848.163" width="82.7477" height="82.7477">
          <div
            xmlns="http://www.w3.org/1999/xhtml"
            style="
              backdrop-filter: blur(3.14px);
              clip-path: url(#bgblur_8_1844_3274_clip_path);
              height: 100%;
              width: 100%;
            "
          ></div>
        </foreignObject>
        <rect
          data-figma-bg-blur-radius="6.28464"
          x="268.111"
          y="855.924"
          width="67.2266"
          height="67.2266"
          rx="8.99845"
          fill="#101010"
          fill-opacity="0.26"
          stroke="url(#paint13_linear_1844_3274)"
          stroke-width="2.95191"
        />
        <g filter="url(#filter9_f_1844_3274)">
          <path
            d="M306.344 887.299L307.678 888.606L309.012 889.913L303.131 895.67C302.488 896.302 301.984 896.794 301.572 897.18C300.947 897.768 300.538 898.11 300.187 898.314C299.321 898.815 298.333 899.08 297.327 899.08C296.32 899.08 295.333 898.815 294.466 898.314C293.884 897.975 293 897.402 291.377 895.816C289.755 894.231 289.169 893.361 288.828 892.789C288.315 891.941 288.044 890.974 288.044 889.988C288.044 889.002 288.315 888.035 288.828 887.187C289.174 886.615 289.904 885.888 291.526 884.301L296.676 879.25H293.071L289.718 882.531C287.894 884.322 287.133 885.082 286.629 885.913C285.883 887.146 285.489 888.554 285.489 889.988C285.489 891.422 285.883 892.829 286.629 894.063C287.133 894.895 287.751 895.795 289.573 897.582C291.396 899.37 292.322 899.972 293.165 900.467C294.406 901.187 295.82 901.572 297.262 901.582C298.705 901.593 300.125 901.229 301.376 900.527C301.413 900.507 301.45 900.488 301.486 900.467C302.041 900.144 302.566 899.712 303.374 898.951C303.799 898.551 304.303 898.052 304.933 897.441L309.48 892.987C310.37 892.114 310.627 891.863 310.841 891.338C311.218 890.413 311.23 889.384 310.875 888.45C310.671 887.919 310.423 887.662 309.549 886.77C308.638 885.918 308.376 885.671 307.835 885.471C306.883 885.124 305.833 885.135 304.889 885.503C304.35 885.714 304.094 885.965 303.203 886.838L297.115 892.809L295.78 891.502L294.445 890.196L300.322 884.438C300.966 883.808 301.469 883.314 301.882 882.929C302.506 882.341 302.916 882 303.266 881.796C304.132 881.294 305.121 881.029 306.127 881.029C307.134 881.029 308.122 881.294 308.988 881.796C309.569 882.132 310.382 882.779 312.004 884.368C313.625 885.958 314.284 886.753 314.63 887.326C315.143 888.175 315.414 889.143 315.414 890.129C315.414 891.116 315.143 892.084 314.63 892.932C314.284 893.501 313.555 894.231 311.932 895.816L306.772 900.871H310.377L313.73 897.586C315.555 895.799 316.315 895.04 316.819 894.209C317.566 892.975 317.96 891.567 317.96 890.133C317.96 888.699 317.566 887.291 316.819 886.058C316.315 885.227 315.629 884.398 313.803 882.61C311.976 880.822 311.132 880.148 310.283 879.655C309.042 878.935 307.628 878.55 306.186 878.539C304.743 878.529 303.324 878.893 302.072 879.595L301.963 879.655C301.407 879.974 300.888 880.405 300.072 881.166C299.646 881.566 299.143 882.06 298.513 882.677L293.978 887.127C293.087 887.995 292.832 888.246 292.615 888.772C292.239 889.697 292.227 890.726 292.582 891.659C292.786 892.19 293.034 892.446 293.907 893.34C294.819 894.192 295.081 894.438 295.624 894.638C296.576 894.986 297.626 894.974 298.57 894.605C299.107 894.395 299.363 894.144 300.254 893.271L306.344 887.299Z"
            fill="white"
            fill-opacity="0.64"
          />
        </g>
        <g style="mix-blend-mode: overlay">
          <rect
            x="11"
            y="796"
            width="1199"
            height="758"
            fill="url(#pattern0_1844_3274)"
            fill-opacity="0.1"
          />
        </g>
        <rect
          opacity="0.37"
          x="277.649"
          y="801.11"
          width="47.6374"
          height="45.8662"
          rx="7.352"
          fill="url(#paint14_linear_1844_3274)"
          stroke="#2F2F2F"
          stroke-width="0.773895"
        />
        <rect
          opacity="0.37"
          x="277.649"
          y="932.175"
          width="47.6374"
          height="45.8662"
          rx="7.352"
          fill="url(#paint15_linear_1844_3274)"
          stroke="#2F2F2F"
          stroke-width="0.773895"
        />
        <rect
          opacity="0.37"
          x="343.181"
          y="801.11"
          width="47.6374"
          height="45.8662"
          rx="7.352"
          fill="url(#paint16_linear_1844_3274)"
          stroke="#2F2F2F"
          stroke-width="0.773895"
        />
        <rect
          opacity="0.37"
          x="343.181"
          y="932.175"
          width="47.6374"
          height="45.8662"
          rx="7.352"
          fill="url(#paint17_linear_1844_3274)"
          stroke="#2F2F2F"
          stroke-width="0.773895"
        />
        <rect
          opacity="0.37"
          x="343.181"
          y="866.642"
          width="47.6374"
          height="45.8662"
          rx="7.352"
          fill="url(#paint18_linear_1844_3274)"
          stroke="#2F2F2F"
          stroke-width="0.773895"
        />
        <path
          d="M308.335 820.317C308.335 820.875 308.253 821.395 308.094 821.881C307.936 822.367 307.752 822.761 307.554 823.069C307.35 823.376 307.068 823.681 306.698 823.991C306.329 824.301 306.034 824.527 305.808 824.665C305.58 824.807 305.268 824.988 304.864 825.216C304.44 825.454 304.085 825.788 303.8 826.222C303.518 826.656 303.374 827.001 303.374 827.264C303.374 827.44 303.312 827.606 303.188 827.769C303.064 827.928 302.92 828.01 302.754 828.01H299.035C298.879 828.01 298.748 827.916 298.641 827.722C298.535 827.529 298.478 827.338 298.478 827.142V826.448C298.478 825.59 298.812 824.782 299.484 824.023C300.156 823.265 300.895 822.702 301.701 822.34C302.31 822.06 302.744 821.772 303.002 821.472C303.26 821.172 303.391 820.781 303.391 820.295C303.391 819.861 303.151 819.479 302.67 819.147C302.191 818.817 301.634 818.651 301.004 818.651C300.332 818.651 299.774 818.8 299.328 819.1C298.966 819.358 298.411 819.955 297.669 820.882C297.536 821.048 297.377 821.13 297.191 821.13C297.067 821.13 296.936 821.088 296.802 821.006L294.258 819.07C294.124 818.966 294.042 818.839 294.018 818.681C293.99 818.525 294.02 818.381 294.102 818.247C295.756 815.503 298.155 814.127 301.296 814.127C302.124 814.127 302.955 814.285 303.793 814.605C304.631 814.925 305.385 815.354 306.056 815.892C306.728 816.43 307.276 817.089 307.7 817.868C308.124 818.641 308.335 819.462 308.335 820.317ZM303.438 829.621V833.34C303.438 833.506 303.376 833.65 303.252 833.774C303.129 833.898 302.985 833.96 302.819 833.96H299.097C298.931 833.96 298.788 833.898 298.664 833.774C298.54 833.65 298.478 833.506 298.478 833.34V829.621C298.478 829.455 298.54 829.311 298.664 829.187C298.788 829.063 298.931 829.001 299.097 829.001H302.819C302.985 829.001 303.129 829.063 303.252 829.187C303.376 829.311 303.438 829.453 303.438 829.621Z"
          fill="#272727"
        />
        <path
          d="M308.335 953.743C308.335 954.301 308.253 954.822 308.094 955.307C307.936 955.793 307.752 956.188 307.554 956.495C307.35 956.802 307.068 957.107 306.698 957.417C306.329 957.727 306.034 957.953 305.808 958.092C305.58 958.233 305.268 958.414 304.864 958.642C304.44 958.88 304.085 959.215 303.8 959.648C303.518 960.082 303.374 960.427 303.374 960.69C303.374 960.866 303.312 961.032 303.188 961.195C303.064 961.354 302.92 961.436 302.754 961.436H299.035C298.879 961.436 298.748 961.342 298.641 961.148C298.535 960.955 298.478 960.764 298.478 960.568V959.874C298.478 959.016 298.812 958.208 299.484 957.449C300.156 956.691 300.895 956.128 301.701 955.766C302.31 955.486 302.744 955.198 303.002 954.898C303.26 954.598 303.391 954.207 303.391 953.721C303.391 953.287 303.151 952.905 302.67 952.573C302.191 952.243 301.634 952.077 301.004 952.077C300.332 952.077 299.774 952.226 299.328 952.526C298.966 952.784 298.411 953.381 297.669 954.308C297.536 954.474 297.377 954.556 297.191 954.556C297.067 954.556 296.936 954.514 296.802 954.432L294.258 952.496C294.124 952.392 294.042 952.266 294.018 952.107C293.99 951.951 294.02 951.807 294.102 951.673C295.756 948.929 298.155 947.553 301.296 947.553C302.124 947.553 302.955 947.711 303.793 948.031C304.631 948.351 305.385 948.78 306.056 949.318C306.728 949.856 307.276 950.515 307.7 951.294C308.124 952.067 308.335 952.888 308.335 953.743ZM303.438 963.047V966.766C303.438 966.932 303.376 967.076 303.252 967.2C303.129 967.324 302.985 967.386 302.819 967.386H299.097C298.931 967.386 298.788 967.324 298.664 967.2C298.54 967.076 298.478 966.932 298.478 966.766V963.047C298.478 962.881 298.54 962.737 298.664 962.614C298.788 962.49 298.931 962.428 299.097 962.428H302.819C302.985 962.428 303.129 962.49 303.252 962.614C303.376 962.737 303.438 962.879 303.438 963.047Z"
          fill="#272727"
        />
      </g>
      <text
        fill="#BFBFBF"
        xml:space="preserve"
        style="white-space: pre"
        font-family="Inter"
        font-size="16"
        font-weight="600"
        letter-spacing="0.01em"
      >
        <tspan x="48" y="403.818">Each validator independently</tspan>
        <tspan x="48" y="427.818">obtains the BTC block hash. The</tspan>
        <tspan x="48" y="451.818">validator reached consensus when</tspan>
        <tspan x="48" y="475.818">more than 2/3 validators voted</tspan>
        <tspan x="48" y="499.818">same hash that is consistent with</tspan>
        <tspan x="48" y="523.818">block hash.</tspan>
      </text>
      <line x1="24" y1="543.5" x2="334" y2="543.5" stroke="#282828" />
      <text
        fill="#BFBFBF"
        xml:space="preserve"
        style="white-space: pre"
        font-family="Inter"
        font-size="16"
        font-weight="600"
        letter-spacing="0.01em"
      >
        <tspan x="48" y="575.818">The block is reached consensus</tspan>
        <tspan x="48" y="599.818">when both BTC and XSAT validator</tspan>
        <tspan x="48" y="623.818">voted same hash consistent with</tspan>
        <tspan x="48" y="647.818">current block hash.</tspan>
      </text>
      <line x1="24" y1="667.5" x2="334" y2="667.5" stroke="#282828" />
      <text
        fill="#BFBFBF"
        xml:space="preserve"
        style="white-space: pre"
        font-family="Inter"
        font-size="16"
        font-weight="600"
        letter-spacing="0.01em"
      >
        <tspan x="48" y="699.818">The block is finalized when the</tspan>
        <tspan x="48" y="723.818">voted hash reached by validators is</tspan>
        <tspan x="48" y="747.818">consistent with the hash submitted</tspan>
        <tspan x="48" y="771.818">by the synchronizer.</tspan>
      </text>
      <rect x="12.5" y="300.5" width="333" height="53" rx="7.5" fill="#111111" />
      <rect x="12.5" y="300.5" width="333" height="53" rx="7.5" stroke="#202020" />
      <g filter="url(#filter10_dddddd_1844_3274)">
        <text
          transform="translate(28 308)"
          fill="#F8F8F8"
          xml:space="preserve"
          style="white-space: pre"
          font-family="Chakra Petch"
          font-size="16"
          font-weight="bold"
          letter-spacing="-0.01em"
        >
          <tspan x="0" y="14.972">The consensus is reached through the</tspan>
          <tspan x="0" y="33.972">following steps.</tspan>
        </text>
      </g>
      <g filter="url(#filter11_dddi_1844_3274)">
        <circle cx="325" cy="327" r="5" fill="url(#paint19_linear_1844_3274)" />
      </g>
    </g>
    <g clip-path="url(#clip9_1844_3274)">
      <rect y="1009" width="358" height="572" rx="24" fill="#131313" />
      <text
        fill="#BFBFBF"
        xml:space="preserve"
        style="white-space: pre"
        font-family="Inter"
        font-size="16"
        font-weight="600"
        letter-spacing="0.01em"
      >
        <tspan x="48" y="1124.82">Delegated staking are allowed for</tspan>
        <tspan x="48" y="1148.82">BTC validators, and the BTC stakers</tspan>
        <tspan x="48" y="1172.82">will share the rewards when the</tspan>
        <tspan x="48" y="1196.82">staked validator earned rewards.</tspan>
      </text>
      <line x1="24" y1="1216.5" x2="334" y2="1216.5" stroke="#282828" />
      <text
        fill="#BFBFBF"
        xml:space="preserve"
        style="white-space: pre"
        font-family="Inter"
        font-size="16"
        font-weight="600"
        letter-spacing="0.01em"
      >
        <tspan x="48" y="1248.82">Up to 70% of the block&#39;s token</tspan>
        <tspan x="48" y="1272.82">incentive will be allocated to</tspan>
        <tspan x="48" y="1296.82">participated BTC validators</tspan>
        <tspan x="48" y="1320.82">(depends on if the synchronizer is</tspan>
        <tspan x="48" y="1344.82">also the miner of the uploaded</tspan>
        <tspan x="48" y="1368.82">block), 20% for XSAT validators.</tspan>
      </text>
      <g clip-path="url(#clip10_1844_3274)">
        <rect x="-81" y="1416" width="426.595" height="223.556" rx="18.3938" fill="#1C1C1C" />
        <path
          d="M77.4695 1477.97C97.2782 1425.97 264.945 1421.02 285.107 1477.97"
          stroke="#111111"
          stroke-width="10.6118"
        />
        <path
          d="M77.4697 1477.97C77.4697 1455.62 37.4985 1447.84 15.9211 1447.84"
          stroke="#111111"
          stroke-width="10.6118"
        />
        <path
          d="M77.4697 1517.87C77.4697 1540.22 37.4985 1548 15.9211 1548"
          stroke="#111111"
          stroke-width="10.6118"
        />
        <path
          d="M77.4695 1515.75C97.2782 1567.75 264.945 1572.7 285.107 1515.75"
          stroke="#111111"
          stroke-width="10.6118"
        />
        <foreignObject x="24.9549" y="1434.94" width="107.152" height="121.736">
          <div
            xmlns="http://www.w3.org/1999/xhtml"
            style="
              backdrop-filter: blur(14.58px);
              clip-path: url(#bgblur_11_1844_3274_clip_path);
              height: 100%;
              width: 100%;
            "
          ></div>
        </foreignObject>
        <g filter="url(#filter12_d_1844_3274)" data-figma-bg-blur-radius="29.1686">
          <ellipse
            cx="78.5307"
            cy="1488.51"
            rx="24.4072"
            ry="24.4072"
            fill="#2E2E2E"
            style="mix-blend-mode: luminosity"
            shape-rendering="crispEdges"
          />
          <path
            d="M78.5308 1464.79C91.6329 1464.79 102.254 1475.41 102.254 1488.51C102.254 1501.62 91.6329 1512.24 78.5308 1512.24C65.4286 1512.24 54.8072 1501.62 54.8071 1488.51C54.8071 1475.41 65.4286 1464.79 78.5308 1464.79Z"
            stroke="url(#paint20_linear_1844_3274)"
            stroke-opacity="0.25"
            stroke-width="1.36728"
            shape-rendering="crispEdges"
          />
        </g>
        <g clip-path="url(#clip12_1844_3274)">
          <mask
            id="mask2_1844_3274"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="53"
            y="1460"
            width="52"
            height="53"
          >
            <ellipse cx="78.7615" cy="1486.47" rx="25.2686" ry="26.4531" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask2_1844_3274)">
            <path
              d="M68.4771 1482.58C68.4771 1476.76 72.9777 1472.04 78.5304 1472.04C84.083 1472.04 88.5837 1476.76 88.5837 1482.58C88.5837 1488.41 84.083 1493.13 78.5304 1493.13C72.9777 1493.13 68.4771 1488.41 68.4771 1482.58Z"
              fill="url(#paint21_linear_1844_3274)"
            />
            <path
              d="M78.5305 1496.16C89.0706 1496.16 97.6629 1503.71 98.3254 1513.82H58.7356C59.3981 1503.71 67.9905 1496.16 78.5305 1496.16Z"
              fill="url(#paint22_linear_1844_3274)"
              stroke="#B9B9B9"
              stroke-width="0.642294"
            />
          </g>
        </g>
        <rect
          x="41.0359"
          y="1504.08"
          width="73.5752"
          height="18.3938"
          rx="7.42827"
          fill="#070707"
        />
        <rect
          x="41.0359"
          y="1504.08"
          width="73.5752"
          height="18.3938"
          rx="7.42827"
          stroke="#1B1B1B"
          stroke-width="0.707454"
        />
        <text
          fill="#828282"
          xml:space="preserve"
          style="white-space: pre"
          font-family="Chakra Petch"
          font-size="10"
          font-weight="500"
          letter-spacing="0em"
        >
          <tspan x="56.9292" y="1516.47">Validator</tspan>
        </text>
        <g opacity="0.6">
          <foreignObject x="208.738" y="1448.93" width="91.1909" height="104.792">
            <div
              xmlns="http://www.w3.org/1999/xhtml"
              style="
                backdrop-filter: blur(12.89px);
                clip-path: url(#bgblur_13_1844_3274_clip_path);
                height: 100%;
                width: 100%;
              "
            ></div>
          </foreignObject>
          <g filter="url(#filter13_d_1844_3274)" data-figma-bg-blur-radius="25.7867">
            <ellipse
              cx="254.333"
              cy="1494.88"
              rx="19.8087"
              ry="20.1624"
              fill="#343434"
              style="mix-blend-mode: luminosity"
              shape-rendering="crispEdges"
            />
            <path
              d="M254.333 1475.32C264.929 1475.32 273.537 1484.07 273.537 1494.88C273.537 1505.69 264.929 1514.44 254.333 1514.44C243.737 1514.44 235.129 1505.69 235.129 1494.88C235.129 1484.07 243.737 1475.32 254.333 1475.32Z"
              stroke="url(#paint23_linear_1844_3274)"
              stroke-opacity="0.25"
              stroke-width="1.20875"
              shape-rendering="crispEdges"
            />
          </g>
          <g clip-path="url(#clip14_1844_3274)">
            <mask
              id="mask3_1844_3274"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="234"
              y="1471"
              width="42"
              height="45"
            >
              <ellipse cx="254.52" cy="1493.19" rx="20.5079" ry="21.8525" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask3_1844_3274)">
              <path
                d="M246.173 1489.98C246.173 1485.17 249.826 1481.27 254.333 1481.27C258.839 1481.27 262.492 1485.17 262.492 1489.98C262.492 1494.79 258.839 1498.69 254.333 1498.69C249.826 1498.69 246.173 1494.79 246.173 1489.98Z"
                fill="url(#paint24_linear_1844_3274)"
              />
              <path
                d="M254.333 1501.21C262.865 1501.21 269.827 1507.43 270.374 1515.77H238.292C238.839 1507.43 245.801 1501.21 254.333 1501.21Z"
                fill="url(#paint25_linear_1844_3274)"
                stroke="#B9B9B9"
                stroke-width="0.567825"
              />
            </g>
          </g>
        </g>
        <g opacity="0.6">
          <foreignObject x="269.579" y="1448.93" width="91.1909" height="104.792">
            <div
              xmlns="http://www.w3.org/1999/xhtml"
              style="
                backdrop-filter: blur(12.89px);
                clip-path: url(#bgblur_15_1844_3274_clip_path);
                height: 100%;
                width: 100%;
              "
            ></div>
          </foreignObject>
          <g filter="url(#filter14_d_1844_3274)" data-figma-bg-blur-radius="25.7867">
            <ellipse
              cx="315.174"
              cy="1494.88"
              rx="19.8087"
              ry="20.1624"
              fill="#343434"
              style="mix-blend-mode: luminosity"
              shape-rendering="crispEdges"
            />
            <path
              d="M315.174 1475.32C325.77 1475.32 334.378 1484.07 334.378 1494.88C334.378 1505.69 325.771 1514.44 315.174 1514.44C304.578 1514.44 295.97 1505.69 295.97 1494.88C295.97 1484.07 304.578 1475.32 315.174 1475.32Z"
              stroke="url(#paint26_linear_1844_3274)"
              stroke-opacity="0.25"
              stroke-width="1.20875"
              shape-rendering="crispEdges"
            />
          </g>
          <g clip-path="url(#clip16_1844_3274)">
            <mask
              id="mask4_1844_3274"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="294"
              y="1471"
              width="42"
              height="45"
            >
              <ellipse cx="315.362" cy="1493.19" rx="20.5079" ry="21.8525" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask4_1844_3274)">
              <path
                d="M307.014 1489.98C307.014 1485.17 310.667 1481.27 315.173 1481.27C319.68 1481.27 323.333 1485.17 323.333 1489.98C323.333 1494.79 319.68 1498.69 315.173 1498.69C310.667 1498.69 307.014 1494.79 307.014 1489.98Z"
                fill="url(#paint27_linear_1844_3274)"
              />
              <path
                d="M315.174 1501.21C323.706 1501.21 330.668 1507.43 331.215 1515.77H299.133C299.68 1507.43 306.642 1501.21 315.174 1501.21Z"
                fill="url(#paint28_linear_1844_3274)"
                stroke="#B9B9B9"
                stroke-width="0.567825"
              />
            </g>
          </g>
        </g>
        <foreignObject x="231.532" y="1434.94" width="107.152" height="121.736">
          <div
            xmlns="http://www.w3.org/1999/xhtml"
            style="
              backdrop-filter: blur(14.58px);
              clip-path: url(#bgblur_17_1844_3274_clip_path);
              height: 100%;
              width: 100%;
            "
          ></div>
        </foreignObject>
        <g filter="url(#filter15_d_1844_3274)" data-figma-bg-blur-radius="29.1686">
          <ellipse
            cx="285.107"
            cy="1488.51"
            rx="24.4072"
            ry="24.4072"
            fill="#2E2E2E"
            style="mix-blend-mode: luminosity"
            shape-rendering="crispEdges"
          />
          <path
            d="M285.107 1464.79C298.21 1464.79 308.831 1475.41 308.831 1488.51C308.831 1501.62 298.21 1512.24 285.107 1512.24C272.005 1512.24 261.384 1501.62 261.384 1488.51C261.384 1475.41 272.005 1464.79 285.107 1464.79Z"
            stroke="url(#paint29_linear_1844_3274)"
            stroke-opacity="0.25"
            stroke-width="1.36728"
            shape-rendering="crispEdges"
          />
        </g>
        <g clip-path="url(#clip18_1844_3274)">
          <mask
            id="mask5_1844_3274"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="260"
            y="1460"
            width="51"
            height="53"
          >
            <ellipse cx="285.338" cy="1486.47" rx="25.2686" ry="26.4531" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask5_1844_3274)">
            <path
              d="M275.053 1482.58C275.053 1476.76 279.554 1472.04 285.107 1472.04C290.659 1472.04 295.16 1476.76 295.16 1482.58C295.16 1488.41 290.659 1493.13 285.107 1493.13C279.554 1493.13 275.053 1488.41 275.053 1482.58Z"
              fill="url(#paint30_linear_1844_3274)"
            />
            <path
              d="M285.107 1496.16C295.648 1496.16 304.24 1503.71 304.902 1513.82H265.312C265.975 1503.71 274.567 1496.16 285.107 1496.16Z"
              fill="url(#paint31_linear_1844_3274)"
              stroke="#B9B9B9"
              stroke-width="0.642294"
            />
          </g>
        </g>
        <rect
          x="259.639"
          y="1505.49"
          width="50.9367"
          height="18.3938"
          rx="7.42827"
          fill="#070707"
        />
        <rect
          x="259.639"
          y="1505.49"
          width="50.9367"
          height="18.3938"
          rx="7.42827"
          stroke="#1B1B1B"
          stroke-width="0.707454"
        />
        <text
          fill="#828282"
          xml:space="preserve"
          style="white-space: pre"
          font-family="Chakra Petch"
          font-size="10"
          font-weight="500"
          letter-spacing="0em"
        >
          <tspan x="267.87" y="1517.89">Stakers</tspan>
        </text>
        <rect
          x="158.827"
          y="1471.89"
          width="45.4406"
          height="43.5859"
          rx="21.7929"
          fill="url(#paint32_linear_1844_3274)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M176.798 1484.72L180.777 1485.73L181.666 1482.58L183.655 1483.1L182.801 1486.11L184.423 1486.52L185.279 1483.48L187.303 1483.99L186.431 1487.05C186.431 1487.05 189.736 1487.75 190.513 1490.3C191.291 1492.84 188.804 1494.18 188.036 1494.23C188.036 1494.23 190.932 1495.74 189.937 1498.7C188.943 1501.67 185.89 1502.2 182.678 1501.52L181.806 1504.69L179.782 1504.18L180.671 1501.05L179.066 1500.64L178.177 1503.79L176.169 1503.27L177.06 1500.14L172.976 1499.1L174.005 1496.93C174.005 1496.93 175.157 1497.23 175.593 1497.33C176.029 1497.42 176.309 1496.99 176.432 1496.56C176.554 1496.13 178.404 1489.01 178.578 1488.42C178.753 1487.84 178.682 1487.38 177.949 1487.2C177.215 1487.02 176.218 1486.74 176.218 1486.74L176.798 1484.72ZM180.811 1494.15L179.71 1498.3C179.71 1498.3 185.172 1500.17 185.871 1497.54C186.57 1494.91 180.811 1494.15 180.811 1494.15ZM181.318 1492.18L182.399 1488.37C182.399 1488.37 187.076 1489.17 186.5 1491.29C185.924 1493.4 183.167 1492.59 181.318 1492.18Z"
          fill="url(#paint33_linear_1844_3274)"
        />
        <path
          d="M216.838 1493.11L221.083 1489.44L221.083 1496.79L216.838 1493.11Z"
          fill="#4A4A4A"
        />
        <path
          d="M122.039 1493.11L126.284 1489.44L126.284 1496.79L122.039 1493.11Z"
          fill="#4A4A4A"
        />
        <path
          d="M133.358 1493.11L137.603 1489.44L137.603 1496.79L133.358 1493.11Z"
          fill="#4A4A4A"
        />
        <path
          d="M144.678 1493.11L148.922 1489.44L148.922 1496.79L144.678 1493.11Z"
          fill="#4A4A4A"
        />
        <g filter="url(#filter16_f_1844_3274)">
          <rect
            x="223.687"
            y="1547.35"
            width="11.3193"
            height="10.8573"
            rx="5.42863"
            transform="rotate(-11.0249 223.687 1547.35)"
            fill="url(#paint34_linear_1844_3274)"
          />
          <path
            d="M231.185 1550.92L231.529 1551.15L231.873 1551.37L230.843 1552.87C230.73 1553.03 230.642 1553.16 230.569 1553.26C230.459 1553.41 230.385 1553.51 230.317 1553.57C230.151 1553.71 229.948 1553.81 229.73 1553.85C229.513 1553.89 229.288 1553.88 229.079 1553.81C228.939 1553.76 228.723 1553.67 228.305 1553.4C227.887 1553.12 227.723 1552.96 227.625 1552.85C227.478 1552.69 227.379 1552.49 227.338 1552.27C227.296 1552.06 227.314 1551.84 227.389 1551.64C227.44 1551.5 227.567 1551.31 227.851 1550.9L228.753 1549.59L227.973 1549.74L227.385 1550.59C227.066 1551.05 226.933 1551.25 226.859 1551.45C226.75 1551.75 226.724 1552.07 226.784 1552.38C226.845 1552.69 226.989 1552.98 227.203 1553.22C227.347 1553.38 227.519 1553.54 227.989 1553.85C228.459 1554.16 228.685 1554.26 228.888 1554.33C229.187 1554.43 229.509 1554.45 229.822 1554.4C230.135 1554.34 230.427 1554.2 230.668 1553.99C230.675 1553.99 230.682 1553.98 230.689 1553.98C230.796 1553.88 230.891 1553.77 231.034 1553.57C231.109 1553.46 231.197 1553.33 231.308 1553.18L232.104 1552.02C232.26 1551.79 232.305 1551.73 232.329 1551.61C232.372 1551.39 232.331 1551.17 232.215 1550.98C232.148 1550.87 232.084 1550.83 231.857 1550.67C231.624 1550.53 231.557 1550.48 231.431 1550.46C231.21 1550.43 230.984 1550.47 230.795 1550.59C230.687 1550.66 230.642 1550.73 230.486 1550.95L229.42 1552.5L229.076 1552.28L228.732 1552.05L229.761 1550.56C229.874 1550.39 229.962 1550.26 230.035 1550.16C230.146 1550.01 230.22 1549.92 230.287 1549.86C230.453 1549.71 230.656 1549.62 230.874 1549.57C231.092 1549.53 231.317 1549.55 231.526 1549.62C231.666 1549.67 231.869 1549.77 232.287 1550.05C232.705 1550.32 232.881 1550.47 232.98 1550.58C233.127 1550.74 233.227 1550.94 233.268 1551.15C233.31 1551.36 233.292 1551.59 233.217 1551.79C233.166 1551.93 233.039 1552.12 232.754 1552.53L231.851 1553.84L232.631 1553.69L233.218 1552.84C233.538 1552.37 233.671 1552.18 233.745 1551.98C233.854 1551.68 233.88 1551.36 233.82 1551.04C233.759 1550.73 233.614 1550.45 233.401 1550.21C233.257 1550.05 233.073 1549.9 232.602 1549.59C232.132 1549.28 231.92 1549.17 231.716 1549.1C231.417 1549 231.095 1548.97 230.782 1549.03C230.469 1549.09 230.177 1549.23 229.936 1549.43L229.915 1549.45C229.808 1549.54 229.714 1549.66 229.569 1549.86C229.494 1549.96 229.406 1550.09 229.295 1550.25L228.501 1551.41C228.345 1551.63 228.3 1551.7 228.276 1551.82C228.233 1552.04 228.274 1552.26 228.39 1552.45C228.457 1552.55 228.521 1552.6 228.748 1552.75C228.981 1552.9 229.049 1552.94 229.174 1552.96C229.395 1553 229.622 1552.95 229.811 1552.83C229.918 1552.76 229.963 1552.7 230.119 1552.47L231.185 1550.92Z"
            fill="url(#paint35_linear_1844_3274)"
          />
        </g>
        <g filter="url(#filter17_f_1844_3274)">
          <rect
            x="132.777"
            y="1436.94"
            width="11.3193"
            height="10.8573"
            rx="5.42863"
            transform="rotate(-9.35905 132.777 1436.94)"
            fill="url(#paint36_linear_1844_3274)"
          />
          <path
            d="M140.169 1440.73L140.507 1440.96L140.844 1441.2L139.771 1442.66C139.653 1442.82 139.561 1442.95 139.486 1443.05C139.371 1443.2 139.294 1443.29 139.225 1443.34C139.054 1443.48 138.849 1443.58 138.63 1443.61C138.411 1443.65 138.186 1443.63 137.98 1443.55C137.841 1443.5 137.628 1443.4 137.218 1443.12C136.808 1442.83 136.65 1442.66 136.555 1442.55C136.413 1442.38 136.319 1442.18 136.284 1441.97C136.248 1441.75 136.273 1441.53 136.354 1441.33C136.409 1441.19 136.541 1441.01 136.838 1440.6L137.777 1439.32L136.993 1439.45L136.381 1440.28C136.048 1440.74 135.91 1440.93 135.83 1441.13C135.712 1441.43 135.676 1441.75 135.728 1442.06C135.779 1442.37 135.915 1442.66 136.122 1442.9C136.261 1443.07 136.428 1443.24 136.889 1443.56C137.35 1443.89 137.573 1443.99 137.774 1444.06C138.07 1444.18 138.391 1444.21 138.706 1444.16C139.02 1444.11 139.316 1443.98 139.563 1443.78C139.57 1443.78 139.578 1443.77 139.585 1443.77C139.694 1443.67 139.792 1443.56 139.941 1443.37C140.019 1443.27 140.111 1443.14 140.226 1442.98L141.056 1441.85C141.218 1441.63 141.265 1441.56 141.293 1441.44C141.342 1441.23 141.307 1441 141.197 1440.81C141.133 1440.71 141.07 1440.66 140.848 1440.5C140.619 1440.34 140.553 1440.3 140.428 1440.27C140.209 1440.23 139.981 1440.27 139.788 1440.39C139.679 1440.45 139.632 1440.52 139.469 1440.74L138.359 1442.26L138.021 1442.02L137.684 1441.78L138.756 1440.32C138.874 1440.16 138.966 1440.03 139.042 1439.93C139.157 1439.78 139.234 1439.7 139.302 1439.64C139.473 1439.5 139.678 1439.4 139.897 1439.37C140.116 1439.33 140.341 1439.35 140.548 1439.43C140.686 1439.49 140.886 1439.6 141.296 1439.88C141.706 1440.17 141.878 1440.32 141.974 1440.43C142.116 1440.6 142.209 1440.8 142.245 1441.02C142.28 1441.23 142.256 1441.45 142.175 1441.65C142.12 1441.79 141.987 1441.98 141.691 1442.38L140.749 1443.66L141.534 1443.53L142.146 1442.7C142.479 1442.24 142.617 1442.05 142.697 1441.85C142.815 1441.56 142.85 1441.24 142.799 1440.93C142.747 1440.61 142.611 1440.32 142.404 1440.08C142.265 1439.92 142.086 1439.76 141.624 1439.44C141.163 1439.11 140.955 1439 140.753 1438.92C140.457 1438.81 140.135 1438.78 139.821 1438.82C139.507 1438.87 139.211 1439 138.964 1439.2L138.942 1439.22C138.832 1439.31 138.735 1439.42 138.585 1439.62C138.506 1439.72 138.415 1439.84 138.3 1440L137.472 1441.13C137.31 1441.35 137.263 1441.42 137.235 1441.54C137.186 1441.75 137.22 1441.98 137.331 1442.17C137.395 1442.28 137.458 1442.32 137.68 1442.49C137.909 1442.64 137.975 1442.68 138.1 1442.71C138.32 1442.75 138.548 1442.71 138.74 1442.59C138.849 1442.53 138.896 1442.47 139.058 1442.24L140.169 1440.73Z"
            fill="url(#paint37_linear_1844_3274)"
          />
        </g>
        <rect
          x="-33.1372"
          y="1427.78"
          width="57.0839"
          height="100.946"
          rx="8.80991"
          fill="#0D0D0D"
          stroke="#202020"
          stroke-width="0.927359"
        />
        <rect
          x="-33.1372"
          y="1533.19"
          width="57.0839"
          height="27.3708"
          rx="8.80991"
          fill="#0D0D0D"
          stroke="#202020"
          stroke-width="0.927359"
        />
        <g clip-path="url(#clip19_1844_3274)">
          <line
            x1="-24.4038"
            y1="1434.04"
            x2="22.9956"
            y2="1434.04"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1437.58"
            x2="22.9956"
            y2="1437.58"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1441.11"
            x2="22.9956"
            y2="1441.11"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1444.65"
            x2="22.9956"
            y2="1444.65"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1448.19"
            x2="22.9956"
            y2="1448.19"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1451.73"
            x2="22.9956"
            y2="1451.73"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1455.26"
            x2="22.9956"
            y2="1455.26"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1458.8"
            x2="22.9956"
            y2="1458.8"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1462.34"
            x2="22.9956"
            y2="1462.34"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1465.88"
            x2="22.9956"
            y2="1465.88"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1469.41"
            x2="22.9956"
            y2="1469.41"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1472.95"
            x2="22.9956"
            y2="1472.95"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1476.49"
            x2="22.9956"
            y2="1476.49"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1480.02"
            x2="22.9956"
            y2="1480.02"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1483.56"
            x2="22.9956"
            y2="1483.56"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1487.1"
            x2="22.9956"
            y2="1487.1"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1490.64"
            x2="22.9956"
            y2="1490.64"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1494.17"
            x2="22.9956"
            y2="1494.17"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1497.71"
            x2="22.9956"
            y2="1497.71"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1501.25"
            x2="22.9956"
            y2="1501.25"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1504.79"
            x2="22.9956"
            y2="1504.79"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1508.32"
            x2="22.9956"
            y2="1508.32"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1511.86"
            x2="22.9956"
            y2="1511.86"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1515.4"
            x2="22.9956"
            y2="1515.4"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1518.93"
            x2="22.9956"
            y2="1518.93"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1522.47"
            x2="22.9956"
            y2="1522.47"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1526.01"
            x2="22.9956"
            y2="1526.01"
            stroke="#171717"
            stroke-width="0.707454"
          />
        </g>
        <g clip-path="url(#clip20_1844_3274)">
          <line
            x1="-24.4038"
            y1="1536.62"
            x2="22.9956"
            y2="1536.62"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1540.16"
            x2="22.9956"
            y2="1540.16"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1543.7"
            x2="22.9956"
            y2="1543.7"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1547.23"
            x2="22.9956"
            y2="1547.23"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1550.77"
            x2="22.9956"
            y2="1550.77"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1554.31"
            x2="22.9956"
            y2="1554.31"
            stroke="#171717"
            stroke-width="0.707454"
          />
          <line
            x1="-24.4038"
            y1="1557.84"
            x2="22.9956"
            y2="1557.84"
            stroke="#171717"
            stroke-width="0.707454"
          />
        </g>
        <g filter="url(#filter18_dddddd_1844_3274)">
          <text
            transform="translate(8 1458) rotate(-90)"
            fill="#828282"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Chakra Petch"
            font-size="10"
            font-weight="500"
            letter-spacing="0em"
          >
            <tspan x="0.0830078" y="10.92">70%</tspan>
          </text>
        </g>
        <g filter="url(#filter19_dddddd_1844_3274)">
          <text
            transform="translate(8 1557.21) rotate(-90)"
            fill="#828282"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Chakra Petch"
            font-size="10"
            font-weight="500"
            letter-spacing="0em"
          >
            <tspan x="0.324219" y="10.92">20%</tspan>
          </text>
        </g>
        <g style="mix-blend-mode: overlay">
          <rect
            x="-81"
            y="1416"
            width="1199"
            height="758"
            fill="url(#pattern1_1844_3274)"
            fill-opacity="0.1"
          />
        </g>
      </g>
      <rect x="12.5" y="1021.5" width="333" height="53" rx="7.5" fill="#111111" />
      <rect x="12.5" y="1021.5" width="333" height="53" rx="7.5" stroke="#202020" />
      <g filter="url(#filter20_dddddd_1844_3274)">
        <text
          transform="translate(28 1029)"
          fill="#F8F8F8"
          xml:space="preserve"
          style="white-space: pre"
          font-family="Chakra Petch"
          font-size="16"
          font-weight="bold"
          letter-spacing="-0.01em"
        >
          <tspan x="0" y="14.972">Validate BTC blocks and sign the</tspan>
          <tspan x="0" y="33.972">consensus will earn XSAT rewards.</tspan>
        </text>
      </g>
      <g filter="url(#filter21_dddi_1844_3274)">
        <circle cx="325" cy="1048" r="5" fill="url(#paint38_linear_1844_3274)" />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_1844_3274"
        x="8.62492"
        y="787.721"
        width="93.3075"
        height="106.007"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="19.05" />
        <feGaussianBlur stdDeviation="9.52499" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend mode="multiply" in2="BackgroundImageFix" result="effect1_dropShadow_1844_3274" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1844_3274"
          result="shape"
        />
      </filter>
      <clipPath id="bgblur_2_1844_3274_clip_path" transform="translate(-8.62492 -787.721)">
        <ellipse cx="55.2786" cy="834.375" rx="21.2537" ry="21.2537" />
      </clipPath>
      <filter
        id="filter1_d_1844_3274"
        x="8.62492"
        y="880.411"
        width="93.3075"
        height="106.007"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="19.05" />
        <feGaussianBlur stdDeviation="9.52499" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend mode="multiply" in2="BackgroundImageFix" result="effect1_dropShadow_1844_3274" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1844_3274"
          result="shape"
        />
      </filter>
      <clipPath id="bgblur_4_1844_3274_clip_path" transform="translate(-8.62492 -880.411)">
        <ellipse cx="55.2786" cy="927.065" rx="21.2537" ry="21.2537" />
      </clipPath>
      <filter
        id="filter2_dddddd_1844_3274"
        x="-138.099"
        y="570.918"
        width="640.688"
        height="612.78"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="4.54942" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1844_3274" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="9.09883" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1844_3274"
          result="effect2_dropShadow_1844_3274"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="31.8459" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_1844_3274"
          result="effect3_dropShadow_1844_3274"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="63.6918" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect3_dropShadow_1844_3274"
          result="effect4_dropShadow_1844_3274"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="109.186" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect4_dropShadow_1844_3274"
          result="effect5_dropShadow_1844_3274"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="149.926" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect5_dropShadow_1844_3274"
          result="effect6_dropShadow_1844_3274"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect6_dropShadow_1844_3274"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_dddddd_1844_3274"
        x="153.927"
        y="876.228"
        width="57.1533"
        height="54.3793"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="0.240702" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.933333 0 0 0 0 0.690196 0 0 0 0 0.266667 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1844_3274" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="0.481404" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.933333 0 0 0 0 0.690196 0 0 0 0 0.266667 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1844_3274"
          result="effect2_dropShadow_1844_3274"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1.68492" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.933333 0 0 0 0 0.690196 0 0 0 0 0.266667 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_1844_3274"
          result="effect3_dropShadow_1844_3274"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="3.36983" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.933333 0 0 0 0 0.690196 0 0 0 0 0.266667 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect3_dropShadow_1844_3274"
          result="effect4_dropShadow_1844_3274"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="5.77685" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.933333 0 0 0 0 0.690196 0 0 0 0 0.266667 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect4_dropShadow_1844_3274"
          result="effect5_dropShadow_1844_3274"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="10.1095" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.933333 0 0 0 0 0.690196 0 0 0 0 0.266667 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect5_dropShadow_1844_3274"
          result="effect6_dropShadow_1844_3274"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect6_dropShadow_1844_3274"
          result="shape"
        />
      </filter>
      <filter
        id="filter4_f_1844_3274"
        x="113.136"
        y="827.29"
        width="22.4345"
        height="11.2172"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="0.590381" result="effect1_foregroundBlur_1844_3274" />
      </filter>
      <filter
        id="filter5_f_1844_3274"
        x="120.221"
        y="828.471"
        width="7.675"
        height="8.85567"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="0.590381" result="effect1_foregroundBlur_1844_3274" />
      </filter>
      <filter
        id="filter6_f_1844_3274"
        x="149.74"
        y="943.595"
        width="22.4345"
        height="11.2172"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="0.590381" result="effect1_foregroundBlur_1844_3274" />
      </filter>
      <filter
        id="filter7_f_1844_3274"
        x="156.824"
        y="944.776"
        width="7.675"
        height="8.85567"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="0.590381" result="effect1_foregroundBlur_1844_3274" />
      </filter>
      <clipPath id="bgblur_8_1844_3274_clip_path" transform="translate(-260.351 -848.163)">
        <rect x="268.111" y="855.924" width="67.2266" height="67.2266" rx="8.99845" />
      </clipPath>
      <filter
        id="filter9_f_1844_3274"
        x="282.347"
        y="875.397"
        width="38.7553"
        height="29.3283"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="1.57116" result="effect1_foregroundBlur_1844_3274" />
      </filter>
      <pattern
        id="pattern0_1844_3274"
        patternContentUnits="objectBoundingBox"
        width="0.195997"
        height="0.310026"
      >
        <use xlink:href="#image0_1844_3274" transform="scale(0.000417014 0.000659631)" />
      </pattern>
      <filter
        id="filter10_dddddd_1844_3274"
        x="-221.76"
        y="61.576"
        width="786.002"
        height="533.96"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="3.79306" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1844_3274" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="7.58611" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1844_3274"
          result="effect2_dropShadow_1844_3274"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="26.5514" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_1844_3274"
          result="effect3_dropShadow_1844_3274"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="53.1028" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect3_dropShadow_1844_3274"
          result="effect4_dropShadow_1844_3274"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="91.0333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect4_dropShadow_1844_3274"
          result="effect5_dropShadow_1844_3274"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="125" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect5_dropShadow_1844_3274"
          result="effect6_dropShadow_1844_3274"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect6_dropShadow_1844_3274"
          result="shape"
        />
      </filter>
      <filter
        id="filter11_dddi_1844_3274"
        x="302.6"
        y="304.6"
        width="44.8"
        height="44.8"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="8.7" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.6 0 0 0 0 0 0 0 0 1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1844_3274" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2.9" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.6 0 0 0 0 0 0 0 0 1 0" />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1844_3274"
          result="effect2_dropShadow_1844_3274"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="3.1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.6 0 0 0 0 0 0 0 0 1 0" />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_1844_3274"
          result="effect3_dropShadow_1844_3274"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_1844_3274"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.3" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="shape" result="effect4_innerShadow_1844_3274" />
      </filter>
      <filter
        id="filter12_d_1844_3274"
        x="24.9549"
        y="1434.94"
        width="107.152"
        height="121.736"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="21.8765" />
        <feGaussianBlur stdDeviation="10.9382" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend mode="multiply" in2="BackgroundImageFix" result="effect1_dropShadow_1844_3274" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1844_3274"
          result="shape"
        />
      </filter>
      <clipPath id="bgblur_11_1844_3274_clip_path" transform="translate(-24.9549 -1434.94)">
        <ellipse cx="78.5307" cy="1488.51" rx="24.4072" ry="24.4072" />
      </clipPath>
      <filter
        id="filter13_d_1844_3274"
        x="208.738"
        y="1448.93"
        width="91.1909"
        height="104.792"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="19.3401" />
        <feGaussianBlur stdDeviation="9.67003" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend mode="multiply" in2="BackgroundImageFix" result="effect1_dropShadow_1844_3274" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1844_3274"
          result="shape"
        />
      </filter>
      <clipPath id="bgblur_13_1844_3274_clip_path" transform="translate(-208.738 -1448.93)">
        <ellipse cx="254.333" cy="1494.88" rx="19.8087" ry="20.1624" />
      </clipPath>
      <filter
        id="filter14_d_1844_3274"
        x="269.579"
        y="1448.93"
        width="91.1909"
        height="104.792"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="19.3401" />
        <feGaussianBlur stdDeviation="9.67003" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend mode="multiply" in2="BackgroundImageFix" result="effect1_dropShadow_1844_3274" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1844_3274"
          result="shape"
        />
      </filter>
      <clipPath id="bgblur_15_1844_3274_clip_path" transform="translate(-269.579 -1448.93)">
        <ellipse cx="315.174" cy="1494.88" rx="19.8087" ry="20.1624" />
      </clipPath>
      <filter
        id="filter15_d_1844_3274"
        x="231.532"
        y="1434.94"
        width="107.152"
        height="121.736"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="21.8765" />
        <feGaussianBlur stdDeviation="10.9382" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend mode="multiply" in2="BackgroundImageFix" result="effect1_dropShadow_1844_3274" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1844_3274"
          result="shape"
        />
      </filter>
      <clipPath id="bgblur_17_1844_3274_clip_path" transform="translate(-231.532 -1434.94)">
        <ellipse cx="285.107" cy="1488.51" rx="24.4072" ry="24.4072" />
      </clipPath>
      <filter
        id="filter16_f_1844_3274"
        x="223.633"
        y="1545.14"
        width="13.2936"
        height="12.9286"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="0.495218" result="effect1_foregroundBlur_1844_3274" />
      </filter>
      <filter
        id="filter17_f_1844_3274"
        x="132.597"
        y="1434.92"
        width="13.2956"
        height="12.915"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="0.495218" result="effect1_foregroundBlur_1844_3274" />
      </filter>
      <filter
        id="filter18_dddddd_1844_3274"
        x="-57.5286"
        y="1369.05"
        width="146.057"
        height="158.243"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="0.827721" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1844_3274" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1.65544" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1844_3274"
          result="effect2_dropShadow_1844_3274"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="5.79405" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_1844_3274"
          result="effect3_dropShadow_1844_3274"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="11.5881" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect3_dropShadow_1844_3274"
          result="effect4_dropShadow_1844_3274"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="19.8653" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect4_dropShadow_1844_3274"
          result="effect5_dropShadow_1844_3274"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="34.7643" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect5_dropShadow_1844_3274"
          result="effect6_dropShadow_1844_3274"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect6_dropShadow_1844_3274"
          result="shape"
        />
      </filter>
      <filter
        id="filter19_dddddd_1844_3274"
        x="-36.1352"
        y="1488.9"
        width="103.27"
        height="115.674"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="0.573038" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1844_3274" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1.14608" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1844_3274"
          result="effect2_dropShadow_1844_3274"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="4.01127" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_1844_3274"
          result="effect3_dropShadow_1844_3274"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="8.02253" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect3_dropShadow_1844_3274"
          result="effect4_dropShadow_1844_3274"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="13.7529" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect4_dropShadow_1844_3274"
          result="effect5_dropShadow_1844_3274"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="24.0676" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 0 0.509804 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect5_dropShadow_1844_3274"
          result="effect6_dropShadow_1844_3274"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect6_dropShadow_1844_3274"
          result="shape"
        />
      </filter>
      <pattern
        id="pattern1_1844_3274"
        patternContentUnits="objectBoundingBox"
        width="0.195997"
        height="0.310026"
      >
        <use xlink:href="#image0_1844_3274" transform="scale(0.000417014 0.000659631)" />
      </pattern>
      <filter
        id="filter20_dddddd_1844_3274"
        x="-221.84"
        y="782.576"
        width="754.404"
        height="530.424"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="3.79306" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1844_3274" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="7.58611" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1844_3274"
          result="effect2_dropShadow_1844_3274"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="26.5514" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_1844_3274"
          result="effect3_dropShadow_1844_3274"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="53.1028" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect3_dropShadow_1844_3274"
          result="effect4_dropShadow_1844_3274"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="91.0333" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect4_dropShadow_1844_3274"
          result="effect5_dropShadow_1844_3274"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="125" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 0 0.619608 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect5_dropShadow_1844_3274"
          result="effect6_dropShadow_1844_3274"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect6_dropShadow_1844_3274"
          result="shape"
        />
      </filter>
      <filter
        id="filter21_dddi_1844_3274"
        x="302.6"
        y="1025.6"
        width="44.8"
        height="44.8"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="8.7" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.6 0 0 0 0 0 0 0 0 1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1844_3274" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2.9" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.6 0 0 0 0 0 0 0 0 1 0" />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1844_3274"
          result="effect2_dropShadow_1844_3274"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="3.1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.6 0 0 0 0 0 0 0 0 1 0" />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_1844_3274"
          result="effect3_dropShadow_1844_3274"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_1844_3274"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.3" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="shape" result="effect4_innerShadow_1844_3274" />
      </filter>
      <linearGradient
        id="paint0_linear_1844_3274"
        x1="0"
        y1="21"
        x2="358"
        y2="21"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#999999" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1844_3274"
        x1="111.963"
        y1="6.95963e-07"
        x2="137.02"
        y2="41.4567"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="0.505" stop-color="#FF9900" />
        <stop offset="1" stop-color="#FF6B00" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1844_3274"
        x1="55.2786"
        y1="813.121"
        x2="73.7702"
        y2="859.799"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" stop-opacity="0.4" />
        <stop offset="0.4" stop-color="white" stop-opacity="0.01" />
        <stop offset="0.6" stop-color="white" stop-opacity="0.01" />
        <stop offset="1" stop-color="white" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1844_3274"
        x1="53.1533"
        y1="820.56"
        x2="59.2637"
        y2="838.626"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ADADAD" />
        <stop offset="1" stop-color="#5A5A5A" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1844_3274"
        x1="54.7474"
        y1="834.641"
        x2="60.0608"
        y2="855.894"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ADADAD" />
        <stop offset="1" stop-color="#868686" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1844_3274"
        x1="55.2786"
        y1="905.811"
        x2="73.7702"
        y2="952.489"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" stop-opacity="0.4" />
        <stop offset="0.4" stop-color="white" stop-opacity="0.01" />
        <stop offset="0.6" stop-color="white" stop-opacity="0.01" />
        <stop offset="1" stop-color="white" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_1844_3274"
        x1="53.1533"
        y1="913.25"
        x2="59.2637"
        y2="931.315"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ADADAD" />
        <stop offset="1" stop-color="#5A5A5A" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_1844_3274"
        x1="54.7474"
        y1="927.33"
        x2="60.0608"
        y2="948.584"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ADADAD" />
        <stop offset="1" stop-color="#868686" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_1844_3274"
        x1="182.506"
        y1="928.886"
        x2="182.506"
        y2="849.725"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1D1D1D" />
        <stop offset="1" stop-color="#2B2B2B" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_1844_3274"
        x1="179.259"
        y1="910.671"
        x2="185.458"
        y2="896.502"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF9900" />
        <stop offset="1" stop-color="#FBCB84" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_1844_3274"
        x1="124.353"
        y1="828.471"
        x2="124.353"
        y2="837.327"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#404040" />
        <stop offset="1" stop-color="#2C2C2C" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_1844_3274"
        x1="160.957"
        y1="944.776"
        x2="160.957"
        y2="953.632"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#404040" />
        <stop offset="1" stop-color="#2C2C2C" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_1844_3274"
        x1="301.201"
        y1="864.922"
        x2="301.201"
        y2="914.152"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#EFEFEF" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_1844_3274"
        x1="301.724"
        y1="854.448"
        x2="301.724"
        y2="924.626"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#323232" />
        <stop offset="0.470854" stop-color="#212121" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_1844_3274"
        x1="301.468"
        y1="800.723"
        x2="301.468"
        y2="847.363"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_1844_3274"
        x1="301.468"
        y1="931.788"
        x2="301.468"
        y2="978.428"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_1844_3274"
        x1="367"
        y1="800.723"
        x2="367"
        y2="847.363"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_1844_3274"
        x1="367"
        y1="931.788"
        x2="367"
        y2="978.428"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_1844_3274"
        x1="367"
        y1="866.255"
        x2="367"
        y2="912.896"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_1844_3274"
        x1="325"
        y1="328.25"
        x2="325"
        y2="335.125"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF9900" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_1844_3274"
        x1="78.5307"
        y1="1464.11"
        x2="99.7659"
        y2="1517.71"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" stop-opacity="0.4" />
        <stop offset="0.4" stop-color="white" stop-opacity="0.01" />
        <stop offset="0.6" stop-color="white" stop-opacity="0.01" />
        <stop offset="1" stop-color="white" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_1844_3274"
        x1="76.0903"
        y1="1472.65"
        x2="83.1074"
        y2="1493.4"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ADADAD" />
        <stop offset="1" stop-color="#5A5A5A" />
      </linearGradient>
      <linearGradient
        id="paint22_linear_1844_3274"
        x1="77.9205"
        y1="1488.82"
        x2="84.0223"
        y2="1513.23"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ADADAD" />
        <stop offset="1" stop-color="#868686" />
      </linearGradient>
      <linearGradient
        id="paint23_linear_1844_3274"
        x1="254.333"
        y1="1474.72"
        x2="272.102"
        y2="1518.79"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" stop-opacity="0.4" />
        <stop offset="0.4" stop-color="white" stop-opacity="0.01" />
        <stop offset="0.6" stop-color="white" stop-opacity="0.01" />
        <stop offset="1" stop-color="white" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint24_linear_1844_3274"
        x1="252.352"
        y1="1481.78"
        x2="258.231"
        y2="1498.85"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ADADAD" />
        <stop offset="1" stop-color="#5A5A5A" />
      </linearGradient>
      <linearGradient
        id="paint25_linear_1844_3274"
        x1="253.838"
        y1="1495.13"
        x2="258.958"
        y2="1515.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ADADAD" />
        <stop offset="1" stop-color="#868686" />
      </linearGradient>
      <linearGradient
        id="paint26_linear_1844_3274"
        x1="315.174"
        y1="1474.72"
        x2="332.943"
        y2="1518.79"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" stop-opacity="0.4" />
        <stop offset="0.4" stop-color="white" stop-opacity="0.01" />
        <stop offset="0.6" stop-color="white" stop-opacity="0.01" />
        <stop offset="1" stop-color="white" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint27_linear_1844_3274"
        x1="313.193"
        y1="1481.78"
        x2="319.071"
        y2="1498.85"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ADADAD" />
        <stop offset="1" stop-color="#5A5A5A" />
      </linearGradient>
      <linearGradient
        id="paint28_linear_1844_3274"
        x1="314.679"
        y1="1495.13"
        x2="319.799"
        y2="1515.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ADADAD" />
        <stop offset="1" stop-color="#868686" />
      </linearGradient>
      <linearGradient
        id="paint29_linear_1844_3274"
        x1="285.107"
        y1="1464.11"
        x2="306.343"
        y2="1517.71"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" stop-opacity="0.4" />
        <stop offset="0.4" stop-color="white" stop-opacity="0.01" />
        <stop offset="0.6" stop-color="white" stop-opacity="0.01" />
        <stop offset="1" stop-color="white" stop-opacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint30_linear_1844_3274"
        x1="282.667"
        y1="1472.65"
        x2="289.684"
        y2="1493.4"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ADADAD" />
        <stop offset="1" stop-color="#5A5A5A" />
      </linearGradient>
      <linearGradient
        id="paint31_linear_1844_3274"
        x1="284.497"
        y1="1488.82"
        x2="290.599"
        y2="1513.23"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ADADAD" />
        <stop offset="1" stop-color="#868686" />
      </linearGradient>
      <linearGradient
        id="paint32_linear_1844_3274"
        x1="181.547"
        y1="1471.89"
        x2="181.547"
        y2="1515.47"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2A2A2A" />
        <stop offset="1" stop-color="#1E1E1E" />
      </linearGradient>
      <linearGradient
        id="paint33_linear_1844_3274"
        x1="181.819"
        y1="1482.58"
        x2="181.819"
        y2="1504.69"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#3F3F3F" />
        <stop offset="1" stop-color="#505050" />
      </linearGradient>
      <linearGradient
        id="paint34_linear_1844_3274"
        x1="229.346"
        y1="1547.35"
        x2="229.346"
        y2="1558.21"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2A2A2A" />
        <stop offset="1" stop-color="#1E1E1E" />
      </linearGradient>
      <linearGradient
        id="paint35_linear_1844_3274"
        x1="229.816"
        y1="1549.22"
        x2="230.788"
        y2="1554.21"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#636363" />
        <stop offset="1" stop-color="#404040" />
      </linearGradient>
      <linearGradient
        id="paint36_linear_1844_3274"
        x1="138.437"
        y1="1436.94"
        x2="138.437"
        y2="1447.8"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2A2A2A" />
        <stop offset="1" stop-color="#1E1E1E" />
      </linearGradient>
      <linearGradient
        id="paint37_linear_1844_3274"
        x1="138.85"
        y1="1438.98"
        x2="139.677"
        y2="1444"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#636363" />
        <stop offset="1" stop-color="#404040" />
      </linearGradient>
      <linearGradient
        id="paint38_linear_1844_3274"
        x1="325"
        y1="1049.25"
        x2="325"
        y2="1056.13"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF9900" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <clipPath id="clip0_1844_3274">
        <rect y="288" width="358" height="681" rx="24" fill="white" />
      </clipPath>
      <clipPath id="clip1_1844_3274">
        <rect width="356" height="186.561" fill="white" transform="translate(11 796)" />
      </clipPath>
      <clipPath id="clip3_1844_3274">
        <rect width="34.006" height="35.6" fill="white" transform="translate(38.2756 820.029)" />
      </clipPath>
      <clipPath id="clip5_1844_3274">
        <rect width="34.006" height="35.6" fill="white" transform="translate(38.2756 912.718)" />
      </clipPath>
      <clipPath id="clip6_1844_3274">
        <rect width="20.073" height="8.85572" fill="white" transform="translate(114.317 828.471)" />
      </clipPath>
      <clipPath id="clip7_1844_3274">
        <rect width="20.073" height="8.85572" fill="white" transform="translate(150.92 944.776)" />
      </clipPath>
      <clipPath id="clip9_1844_3274">
        <rect y="1009" width="358" height="572" rx="24" fill="white" />
      </clipPath>
      <clipPath id="clip10_1844_3274">
        <rect width="426.595" height="223.556" fill="white" transform="translate(-81 1416)" />
      </clipPath>
      <clipPath id="clip12_1844_3274">
        <rect width="39.0515" height="40.882" fill="white" transform="translate(59.0049 1472.04)" />
      </clipPath>
      <clipPath id="clip14_1844_3274">
        <rect
          width="31.6939"
          height="33.7721"
          fill="white"
          transform="translate(238.486 1481.27)"
        />
      </clipPath>
      <clipPath id="clip16_1844_3274">
        <rect
          width="31.6939"
          height="33.7721"
          fill="white"
          transform="translate(299.327 1481.27)"
        />
      </clipPath>
      <clipPath id="clip18_1844_3274">
        <rect width="39.0515" height="40.882" fill="white" transform="translate(265.582 1472.04)" />
      </clipPath>
      <clipPath id="clip19_1844_3274">
        <rect x="-24.4038" y="1430.86" width="47.3994" height="96.2138" rx="7.07454" fill="white" />
      </clipPath>
      <clipPath id="clip20_1844_3274">
        <rect x="-24.4038" y="1533.44" width="47.3994" height="26.8833" rx="10.6118" fill="white" />
      </clipPath>
      <image
        id="image0_1844_3274"
        width="470"
        height="470"
        preserveAspectRatio="none"
        xlink:href="data:image/png;base64,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"
      />
    </defs>
  </svg>
</template>
